import * as React from 'react';
import { Spinner } from '@cian/ui-kit';
import * as styles from './Loader.css';

export interface ILoaderProps {
  isMobile: boolean;
}

export const Loader = ({ isMobile }: ILoaderProps) => {
  return (
    <div className={styles['wrapper']} data-testid="loader">
      <Spinner size={isMobile ? 30 : 50} />
    </div>
  );
};
